import { Component, Input, OnInit } from '@angular/core';
import { OccasionEligibleUserDto } from 'src/app/data/models/dto/occasion-eligible-user.dto';
import { NewsAuthorizationStatusEnum } from 'src/app/data/models/enum/news-authorization-status.enum';

@Component({
  selector: 'app-news-engagement-item',
  templateUrl: './news-engagement-item.component.html',
  styleUrls: ['./news-engagement-item.component.scss'],
})
export class NewsEngagementItemComponent implements OnInit {
  @Input() newsHasAuthorization: boolean = false;
  @Input() eligibleUser!: OccasionEligibleUserDto;
  @Input() isStudentProfileEligible: boolean = false;
  @Input() isResponsibleProfileEligible: boolean = false;
  authorizationStatusKey: any;
  authorizationStatus = '';

  constructor() {}

  async ngOnInit(): Promise<void> {
    this.setAuthorizationStatus();
    this.authorizationStatusKey = Object.entries(
      NewsAuthorizationStatusEnum
    ).find(([key, val]) => val === this.authorizationStatus)?.[0];
  }

  private setAuthorizationStatus() {
    this.authorizationStatus =
      NewsAuthorizationStatusEnum.AUTHORIZATION_PENDING;
    if (this.eligibleUser.authorized != null) {
      this.authorizationStatus = this.eligibleUser.authorized.answer
        ? NewsAuthorizationStatusEnum.AUTHORIZED
        : NewsAuthorizationStatusEnum.NOT_AUTHORIZED;
    }
  }

  applyStatusCSS() {
    switch (this.authorizationStatusKey) {
      case 'AUTHORIZATION_PENDING':
        return {
          status: true,
          'status-pending': true,
        };
      case 'AUTHORIZED':
        return {
          status: true,
          'status-authorized': true,
        };
      case 'NOT_AUTHORIZED':
        return {
          status: true,
          'status-not-authorized': true,
        };
      default:
        return {
          status: true,
        };
    }
  }
}
